<p>search-location-filter-footer works!</p>
